import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mg-welcome-teacher-manager',
  templateUrl: './WelcomeTeacherManager.component.html',
  styleUrls: ['./WelcomeTeacherManager.component.scss'],
})
export class WelcomeTeacherManagerComponent {
  stepCount = 3;
  step: number = 0;
  _enableGroups: boolean = false;

  @Output()
  done: EventEmitter<void> = new EventEmitter();

  @Input()
  mingaName: string = 'Your Minga';

  @Input()
  set enableGroups(value: boolean) {
    this._enableGroups = value;
    if (!this._enableGroups) {
      this.stepCount = 3;
    } else {
      this.stepCount = 4;
    }
  }

  next() {
    if (this.step + 1 < this.stepCount) {
      this.step++;
    } else {
      this.done.emit();
    }
  }
}
